import { render } from "./topic.vue?vue&type=template&id=24fec866&scoped=true"
import script from "./topic.vue?vue&type=script&lang=js"
export * from "./topic.vue?vue&type=script&lang=js"

import "./topic.vue?vue&type=style&index=0&id=24fec866&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24fec866"]])

export default __exports__